import mobileBottomPanel from 'assets/core/js/module/mobileBottomPanel'
import checkOfferTrigger from 'assets/core/js/page/product/checkOfferTrigger'
import crossSell from 'assets/core/js/page/product/crossSell'
import favorite from 'assets/core/js/page/product/favorite'

/**
 * Setup components that are core on the product page.
 *
 * It should be called only after the DOM content loaded.
 */
export default (): void => {
  mobileBottomPanel('.dca-mobile-bottompanel__toggle:not([data-panel-target="header-bs-mobile-bottompanel"])')
  checkOfferTrigger()

  setTimeout(() => {
    favorite()
    crossSell()
  }, 0)
}
